<template>
	<div>
		<vxe-modal :loading="loading" :title="title" v-model="modal" @show="show" @hide="hide" width="600" height="600" show-footer destroy-on-close >
			<template #default>
				<el-divider content-position="center">付款码</el-divider>
				<el-card v-for="(item,index) in paycode" :key="index" class="card" :body-style="{ padding: '0px' }">
					<el-image class="image" :src="item.url" :preview-src-list="[item.url]">
					</el-image>
					<div style="padding: 14px;">
						<div class="bottom clearfix">
							<el-radio v-model="paycodeId" :label="item.uid">选择</el-radio>
						</div>
					</div>
				</el-card>
				<el-divider content-position="center">付款金额</el-divider>
				<el-input-number v-model="amount" :precision="4" :step="0.0001" label="付款金额"></el-input-number>
				<el-divider content-position="center">付款凭证</el-divider>
				<upload v-model="voucher" :formCreateInject="{}" @change="uploadchange" />
			</template>
			<template #footer>
				<vxe-button size="mini" status="primary" content="确认" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>
	.time {
		font-size: 13px;
		color: #999;
	}

	.bottom {
		margin-top: 13px;
		line-height: 12px;
	}

	.button {
		padding: 0;
		float: right;
	}

	.image {
		width: 100%;
		display: block;
	}

	.clearfix:before,
	.clearfix:after {
		display: table;
		content: "";
	}

	.clearfix:after {
		clear: both
	}

	.card {
		display: inline-block;
		width: 120px;
		margin-right: 20px;
	}
</style>
<script>
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			paycode: {
				type: Array,
				default: () => {
					return {}
				}
			},
			
			title: {
				type: String,
				default: () => {
					return '付款信息'
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				id:0,
				loading: false,
				paycodeId:0,
				modal: false,
				voucher:null,
				amount:0
			}
		},
		watch: {

		},
		methods: {
			init(){
				this.id = 0
				this.amount = 0
				this.paycodeId = 0
				this.voucher = null
				this.loading = true
				this.$api.wlnpurchase.getSettlement(this.row.id).then((res)=>{
					this.loading = false
					if(res){
						this.id = res.id
						this.paycodeId = res.paycode.uid
						this.voucher = res.voucher
						this.amount = res.amount
					}
				})
				
			},
			modalShow() {
				this.modal = true
			},
			modalHide() {
				this.modal = false
			},
			show() {
				this.init()
			},
			hide() {

			},
			uploadchange(e){
				this.voucher = e
			},
			submit(){
				let form = {
					paycode:null,
					voucher:null,
					amount:0
				}
				form.voucher = this.voucher
				form.amount = this.amount
				let paycode = this.paycode.find((item)=>{
					return item.uid == this.paycodeId
				})
				if(paycode){
					form.paycode = paycode
				}
				if(!form.paycode){
					this.$message.error('请选择付款码')
					return
				}
				if(!form.amount){
					this.$message.error('请输入付款金额')
					return
				}
				if(!form.voucher){
					this.$message.error('请选择付款凭证')
					return
				}
				this.loading = true
				this.$api.wlnpurchase.saveSettlement(this.row.id,form).then(()=>{
					this.loading = false
					this.$message.success('操作成功')
					this.modalHide()
					this.list.customreload()
				},()=>{
					this.loading = false
				})
		
			}
		},
		components: {
			upload
		}
	}
</script>